<template>
  <v-container>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <v-card
      v-show="!overlay"
      class="my-4"
    >
      <v-card-title class="text-center">
        Carpool Report Generate Page
      </v-card-title>

      <v-divider />

      <v-card-text>
        <v-form
          ref="form"
          v-model="form"
          lazy-validation
        >
          <v-row>
            <v-col
              cols="12"
              md="3"
            >
              <v-select
                v-model="selectedReportType"
                :items="itemsReportType"
                label="Select Report Type"
                outlined
                hide-details
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <date-picker
                v-model="datePicker.start"
                :masks="datePicker.masks"
                :min-date="datePicker.minimum"
              >
                <template #default="{ inputValue, inputEvents }">
                  <v-text-field
                    :value="inputValue"
                    label="From Date"
                    v-on="inputEvents"
                    outlined
                    clearable
                    :rules="[
                      v => {
                        if (!datePicker.end) return true;
                        return !!v || 'Start date is required!';
                      }
                    ]"
                    hide-details
                  />
                </template>
              </date-picker>
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <date-picker
                v-model="datePicker.end"
                :masks="datePicker.masks"
                :min-date="datePicker.start"
              >
                <template #default="{ inputValue, inputEvents }">
                  <v-text-field
                    :value="inputValue"
                    label="To Date"
                    v-on="inputEvents"
                    outlined
                    clearable
                    :rules="[
                      v => {
                        if (!datePicker.end) return true;
                        return !!v || 'End date is required!';
                      }
                    ]"
                    hide-details
                  />
                </template>
              </date-picker>
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <!-- <v-combobox
                v-model="selectedVehicle"
                :items="vehicles"
                :item-text="(item) => `${item.device_make} - ${item.device_name}`"
                :item-value="(item) => `${item.id}`"
                label="Select Vehicle"
                hide-details
                outlined
              /> -->
              <v-combobox
                v-model="selectedVehicle"
                :items="vehicles"
                :item-text="item => `${item.device_make} - ${item.device_name}`"
                item-value="id"
                label="Select Vehicle"
                multiple
                outlined
                required
              >
                <template #selection="{ item, index }">
                  <v-chip v-if="index === 0">
                    <span>{{ item.device_make }} - {{ item.device_name }}</span>
                  </v-chip>
                  <span
                    v-if="index === 1"
                    class="grey--text caption"
                  >
                    (+{{ selectedVehicle.length - 1 }} others)
                  </span>
                </template>
              </v-combobox>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider />

      <v-card-actions class="mx-2">
        <v-spacer />
        <v-btn
          button
          color="primary"
          @click="handleClickGenerate"
          ref="handleGenerate"
        >
          Generate
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-if="resultReport">
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="getResponseApi"
          class="font-weight-light pa-5"
          :loading="loadingData"
          loading-text="Loading..."
        >
          <template #no-data>
            No data found.
          </template>
          <template #[`item.start_geofence_id`]="{ item }">
            {{ getOriginName(item) }}
          </template>
          <template #[`item.vehicle_name`]="{ item }">
            {{ getVehicleName(item) }}
          </template>
          <template #[`item.end_geofence_id`]="{ item }">
            {{ getDestinationAddr(item) }}
          </template>
          <template #[`item.start_datetime`]="{ item }">
            {{ startDateFormat(item) }}
          </template>
          <template #[`item.end_datetime`]="{ item }">
            {{ endDateFormat(item) }}
          </template>
          <template #[`item.cost_code`]="{ item }">
            {{ getCostCode(item) }}
          </template>
          <template #[`item.late_duration`]="{ item }">
            {{ getLateDuration(item) }}
          </template>
          <template #[`item.created_at`]="{ item }">
            {{ formatDate(item.created_at) }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
/* eslint-disable */

const qs = require("qs");
import isEmpty from "lodash/isEmpty";
import isNull from "lodash/isNull";
import isUndefined from "lodash/isUndefined";
import get from "lodash/get";
import moment from "moment";

export default {
  data() {
    return {
      range: {
        start: new Date(),
        end: new Date()
      },
      datePicker: {
        start: "",
        startUnix: "",
        endUnix: "",
        end: "",
        paramStart: "",
        paramEnd: "",
        masks: {
          input: "DD MMMM YYYY"
        },
        selectedDate: new Date().toISOString().substr(0, 10)
      },
      masks: {
        input: "YYYY-MM-DD"
      },
      overlay: false,
      form: true,
      selectedReportType: "",
      itemsReportType: ["Returned Car Late", "Booked But Not Used"],
      selectedVehicle: [],
      vehicles: [],
      vehicleIds: [],
      resultReport: false,
      getResponseApi: [],
      loadingData: false,
      assetTypes: []
    };
  },
  created() {
    this.overlay = true;
    this.getVehicles();
    this.$store.dispatch("GET_ALL_GEOFENCES");
    this.$store.dispatch("GET_GEOFENCES");
    this.$store.dispatch("LOAD_POOL_DATA");
  },
  watch: {
    overlay(val) {
      val &&
        setTimeout(() => {
          this.overlay = false;
        }, 2e3);
    },
    "datePicker.start"(value) {
      let sDate = moment(value).format("YYYY-MM-DD");
      this.datePicker.paramStart = sDate;
    },
    "datePicker.end"(value) {
      let eDate = moment(value).format("YYYY-MM-DD");
      this.datePicker.paramEnd = eDate;
    },
    selectedVehicle(val) {
      if (isNull(val)) return;
      this.vehicleIds = val.map(v => v.id);
    }
  },
  computed: {
    getPoolData() {
      return this.$store.getters.getPoolData;
    },
    getAvailVehicle() {
      return this.$store.getters.getVehiclesData;
    },
    getDestinationData() {
      return this.$store.getters.getDestinationData;
    },
    all_geofences() {
      return this.$store.getters["getAllGeofencesData"];
    },
    geofences() {
      return this.$store.getters["getGeofencesData"];
    },
    clientid() {
      return this.$store.state.clientid;
    },
    isDarwin() {
      return this.$store.state.clientid === "ED73T6OILP78";
    },
    headers() {
      const baseHeaders = [
        { text: "Booking ID", value: "id" },
        { text: "From", value: "start_geofence_id" },
        { text: "To", value: "end_geofence_id" },
        { text: "Start Date", value: "start_datetime" },
        { text: "End Date", value: "end_datetime" },
        { text: "Asset Name", value: "vehicle_name" },
        { text: "Created At", value: "created_at" }
      ];

      if (this.isDarwin) {
        baseHeaders.push({ text: "Cost Code", value: "cost_code" });
      }

      if (this.selectedReportType === "Returned Car Late") {
        baseHeaders.push({ text: "Late Duration", value: "late_duration" });
      } 

      return baseHeaders;
    }
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
    this.getAssetType();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  methods: {
    onResponsiveInverted() {
      if (window.innerWidth < 1024) {
        this.responsive = false;
      } else {
        this.responsive = true;
      }
    },
    getVehicles() {
      this.$store
        .dispatch("API_CALL", {
          $method: "get_vehicles",
          $postData: {
            clientid: this.clientid
          }
        })
        .then(response => {
          this.vehicles = response.data.data.filter(
            vehicle => !isEmpty(vehicle.type_id) || !isNull(vehicle.type_id)
          );
        });
    },
    getOriginName(item) {
      if (item == null) return;
      let destination = "";
      if (item.start_geofence_id != 0) {
        if (this.$store.state.type == 3) {
          for (var k in this.all_geofences) {
            this.all_geofences[k].forEach(group => {
              const geofenceDestination = group.geofences.find(
                geofence =>
                  parseInt(geofence.Id) === parseInt(item.start_geofence_id)
              );
              if (!isUndefined(geofenceDestination)) {
                destination = geofenceDestination.name;
              }
            });
          }
        } else {
          this.geofences[this.$store.state.clientid].forEach(group => {
            const geofenceDestination = group.geofences.find(
              geofence =>
                parseInt(geofence.Id) === parseInt(item.start_geofence_id)
            );
            if (!isUndefined(geofenceDestination)) {
              destination = geofenceDestination.name;
            }
          });
        }
      }
      return destination;
    },
    getDestinationAddr(item) {
      if (item == null) return;
      let destination = "";
      let stopFind = false;
      if (item.end_geofence_id != 0 && !isEmpty(item.end_geofence_id)) {
        if (this.$store.state.type == 3) {
          for (var k in this.all_geofences) {
            this.all_geofences[k].forEach(group => {
              if (stopFind === false) {
                const geofenceDestination = group.geofences.find(
                  geofence =>
                    parseInt(geofence.Id) === parseInt(item.end_geofence_id)
                );
                if (!isUndefined(geofenceDestination)) {
                  destination = geofenceDestination.name;
                  stopFind = true;
                }
              }
            });
          }
        } else {
          this.geofences[this.$store.state.clientid].forEach(group => {
            if (stopFind === false) {
              const geofenceDestination = group.geofences.find(
                geofence =>
                  parseInt(geofence.Id) === parseInt(item.end_geofence_id)
              );
              if (!isUndefined(geofenceDestination)) {
                destination = geofenceDestination.name;
                stopFind = true;
              }
            }
          });
        }
      } else if (isNull(item.end_geofence_id)) {
        const destination = JSON.parse(item.metadata);
        return destination.address;
      } else if (item.metadata && item.metadata.hasOwnProperty("address")) {
        destination = item.metadata.hasOwnProperty("address")
          ? item.metadata.address
          : `${item.start_longitude},${item.end_longitude}`;
      } else {
        const destination = JSON.parse(item.metadata);
        return destination.address;
      }
      return destination;
    },
    getVehicleName(item) {
      if (item == null) return;
      let vehicleName = "";
      let metadata = JSON.parse(get(item, "metadata", ""));
      if (!isNull(metadata)) {
        const vehicle = this.vehicles.find(d => d.id == item.vehicle_id);
        const typeName = this.assetTypes.find(
          d => d.id == metadata.booking_detail.asset_type
        );
        vehicleName = `${get(typeName, "name", "-")} - ${get(
          vehicle,
          "device_make",
          "-"
        )} ( ${get(vehicle, "device_name", "-")} )`;
      } else {
        vehicleName = "--";
      }
      if (!vehicleName) return;
      return vehicleName;
    },
    getCostCode(item) {
      if (!item) return;
      const metadata = JSON.parse(get(item, "metadata", "") || "{}");
      const costCode = get(metadata, "cost_code", "-") || "--";
      return costCode;
    },
    getLateDuration(item) {
      if (!item) return;
      const metadata = JSON.parse(get(item, "metadata", "") || "{}");
      const lateDuration = get(metadata, "late_duration", "-") || "--";
      return lateDuration;
    },
    getAssetType() {
      this.$store
        .dispatch("API_CALL", {
          $method: "get_asset_types",
          $postData: {
            clientid: this.$store.state.clientid
          }
        })
        .then(response => {
          this.assetTypes = response.data.data;
        });
    },
    startDateFormat(item) {
      if (item == null) return;
      let date = null;
      if (item.hasOwnProperty("start_datetime")) {
        date = moment(item.start_datetime).format("ddd, D MMM YYYY HH:mm");
      }
      return date;
    },
    endDateFormat(item) {
      if (item == null) return;
      let date = null;
      if (item.hasOwnProperty("end_datetime")) {
        date = moment(item.end_datetime).format("ddd, D MMM YYYY HH:mm");
      }
      return date;
    },
    formatDate(date, format = "D MMM YYYY HH:mm") {
      if (date == null) return;
      const dateFormatted = moment(date).format(format);
      return dateFormatted;
    },
    handleClickGenerate() {
      let method = "";
      if (this.selectedReportType === "Returned Car Late") {
        method = "get_returned_late";
      } else {
        method = "get_booked_not_used";
      }
      this.loadingData = true;
      this.$store
        .dispatch("API_CALL", {
          $method: method,
          $postData: {
            start_date: this.datePicker.paramStart,
            end_date: this.datePicker.paramEnd,
            deviceids: this.vehicleIds
          }
        })
        .then(response => {
          if (response.data.code == 200) {
            this.resultReport = true;
            this.getResponseApi = response.data.data;
            this.loadingData = false;
          }
        });
    }
  }
};
</script>
<style lang="css" scoped>
@-moz-keyframes loader {
	from {
		transform: rotate(0);
	}

	to {
		transform: rotate(360deg);
	}
}

@-webkit-keyframes loader {
	from {
		transform: rotate(0);
	}

	to {
		transform: rotate(360deg);
	}
}

@-o-keyframes loader {
	from {
		transform: rotate(0);
	}

	to {
		transform: rotate(360deg);
	}
}

@keyframes loader {
	from {
		transform: rotate(0);
	}

	to {
		transform: rotate(360deg);
	}
}
</style>
